// Category.jsx

import React from 'react';

const Category = ({ categories, handleCategory, activeCategory, fetchBlogs }) => {
  return (
    <div className="flex gap-8 md:gap-16">
      {categories.map((cat, index) => (
        <button
          key={cat.id || cat._id || index}
          data-category-name={cat.name}
          data-category-id={cat.id}
          onClick={() => {
            handleCategory(cat); // Pass the entire category object
          }}
          className={`cursor-pointer w-max capitalize outline-none text-[18px] font-medium sm:font-bold transition-colors duration-300 ease-in-out pb-3 sm:pb-3 md:pb-4 lg:pb-5 border-b-3 border-transparent ${
            activeCategory === cat.name
              ? "text-[#FC9D00] border-b-3 border-yellow-500"
              : "text-[#202124] hover:text-black"
          }`}
        >
          {cat.name}
        </button>
      ))}
    </div>
  );
};

export default Category;